import { useState, useContext, useEffect, useMemo } from "react";
import { ReactComponent as Internet } from "@src/assets/CN/svg/internet.svg";
import { ReactComponent as InternetHover } from "@src/assets/CN/svg/internetHover.svg";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "@src/Basic/Language/Provider.tsx";
import { useStore } from "@src/Store";
import GlobalConfig from "@src/GlobalConfig";
import { IKVProps } from "@src/Model/IKVProps";
import _ from "lodash";

const SwitchLanguage = (props: any) => {
  const { setItem } = props;
  const { setLanguage, language } = useContext(LanguageContext);

  const { commonStore } = useStore();
  const { t, i18n } = useTranslation();

  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [languageDataSource, setLanguageDataSource] = useState<any[]>([]);

  useEffect(() => {
    try {
      const allSupportLanguages = localStorage.getItem("languageList");
      const parseAllSupportLanguages = JSON.parse(allSupportLanguages ?? "[]");

      if (allSupportLanguages) {
        setLanguageDataSource(parseAllSupportLanguages);
      }
    } catch (error) {
      //
    }
  }, [i18n.language]);

  const switchLanguage = (targetLang: IKVProps) => {
    setLanguage(targetLang.value);
    commonStore.setLanguage(targetLang.value);
    setIsHovered(false);
  };

  const handleOnChange = (item: IKVProps) => {
    switchLanguage(item);
    if (item.isForeign) {
      GlobalConfig.pushToInternational();
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    setItem({});
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const languageLabel = useMemo(() => {
    console.log("switch languae", i18n.language, languageDataSource);
    const _languageLabel = _.find(languageDataSource, (o) => o.value === i18n.language)?.label;
    return i18n.getCurrentLanguageLabel() || _languageLabel;
  }, [i18n.language]);

  return (
    <div
      className="flex items-center relative cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isHovered ? (
        <>
          <InternetHover />
          <span className={`languageLabelHover`}>{languageLabel}</span>
        </>
      ) : (
        <>
          <Internet />
          <span className={`languageLabel `}>{languageLabel}</span>
        </>
      )}

      {isHovered && (
        <div className={`absolute switchLanguage`}>
          {languageDataSource.map((item) => {
            return (
              <div
                className={`languageItem`}
                key={item.key}
                onClick={() => {
                  handleOnChange(item);
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SwitchLanguage;
